import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { FirebaseService } from './firebase.service';
import { AuthService } from './auth.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TopicService {
  prefix = `${environment.serverUrl}/topics`;

  constructor(private http: HttpClient, private firebaseService: FirebaseService) {}

  /**
   * Subscribes to topic and triggers observer on each change
   * @param topic to subscribe to, for example edit-job-{{id}}
   * @param observer to be triggered on each change via firebase
   */
  subscribeToTopic(topic: string, observer?: any): Promise<any> {
    return this.subscribeToTopics([topic], observer);
  }
  /**
   * Subscribes to topic and triggers observer on each change
   * @param topics list of topics to subscribe to, for example [edit-job-{{id}}]
   * @param observer to be triggered on each change via firebase
   */
  async subscribeToTopics(topics: string[], observer?: any): Promise<any> {
    const token = await this.firebaseService.getFirebaseToken();
    if (!token) {
      return;
    }
    if (observer) {
      for (const topic of topics) {
        this.firebaseService.subscribe(topic, observer);
      }
    }

    return this.http.post(`${this.prefix}/subscribe`, { topics, token }).toPromise();
  }

  getTopicObservables(topics: string[]): BehaviorSubject<any>[] {
    const subjects: BehaviorSubject<any>[] = [];
    topics.forEach((topic) => {
      let subject = this.firebaseService.getObservable(topic);
      if (!subject) {
        this.firebaseService.subscribe(topic, () => {});
        subject = this.firebaseService.getObservable(topic);
      }
      subjects.push(subject);
    });
    return subjects;
  }

  async unsubscribeFromTopics(topics: string[]): Promise<any> {
    const token = await this.firebaseService.getFirebaseToken();
    if (!token) {
      return;
    }
    return this.http.post(`${this.prefix}/unsubscribe`, { topics, token }).toPromise();
  }
}
